import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import './styles/tableaux.css';
import './styles/shared.css';
import App from './App';

// Mode nuit (2026-09-30) : appliqué AVANT le premier rendu, sinon la page
// s'affiche en clair puis bascule. Choix mémorisé dans le navigateur ; sans
// choix, on suit le réglage du système.
try {
  const t = localStorage.getItem('bi-theme')
    || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  document.documentElement.dataset.theme = t;
} catch (e) { document.documentElement.dataset.theme = 'light'; }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
